import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../../lib/api-client';
import { GetInactiveCompanyUsersResult } from '../types/GetInactiveCompanyUsersResult';

export const useGetInactiveCompanyUsers = (companyID: number) => {
    const { data, isLoading } = useQuery({
        queryKey: ['inactive-company-users', companyID],
        queryFn: async () => await apiClient.get('user/inactive-users') as GetInactiveCompanyUsersResult
    });

    return {
        data,
        isLoading
    };
};
